import Dashboard from '../components/DashboardContainer'

export default Dashboard